import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormEducatoreComponent } from '../form-educatore/form-educatore.component';
import { GenericFormComponent } from '../generic-form/generic-form.component';

@Component({
  selector: 'app-iscriviti',
  templateUrl: './iscriviti.component.html',
  styleUrls: ['./iscriviti.component.scss'],
})
export class IscrivitiComponent implements OnInit, AfterViewInit {
  slideSelected = 1;
  private isProcessing = false;
  constructor(public modalService: NgbModal) {}
  @ViewChild('myElement') myElement!: ElementRef; // Referenza all'elemento nel template

  ngOnInit(): void {}

  
  ngAfterViewInit() {
    const element = this.myElement.nativeElement;
    const mc = new Hammer(element);


    // Aggiungi i riconoscitori per gestire eventi specifici
    mc.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.slideSelected > 1) {
          this.slideSelected--;
        } else {
          this.slideSelected = 2;
        }
      } else if (ev.type === 'panleft') {
        if (this.slideSelected < 2) {
          this.slideSelected++;
        } else {
          this.slideSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });


  }

  openModal(type: string) {
    const modalRef = this.modalService.open(GenericFormComponent, {
      size: 'lg',
      modalDialogClass: 'signup-modal',
      centered: true,
      
    });
    modalRef.componentInstance.type = type;
  }

  changeSlide(id: number) {
    this.slideSelected = id;
  }
}
